/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { ActionsTable } from "ceco-window-table";
import { IngredientDeleteModal } from "../../modals/IngredientDeleteModal";
import { IngredientModal } from "../../modals/IngredientModal";
import { MoreHorizontal, Edit, Delete } from "ceicons";
import DropDownButton from "../../DropDownButton";

export default function IngredientsTable(props) {
  const { ingredientsParsed, totalCount, handleScroll, _refetch } = props;
  const t = useTranslation();

  const columnsTable = [
    {
      key: "name",
      basis: 1,
      title: t("table-header.name"),
    },
    {
      key: "id",
      basis: 1,
      width: 100,
      ItemRenderer: <EditCell refetchData={_refetch} />,
    },
  ];

  return (
    <ActionsTable
      actions={[]}
      allowItemSelection={false}
      footer={
        <div>
          <div className="legend" />
        </div>
      }
      allowAllItemsSelection={false}
      gridActions={[
        <div className="right floated" key="right-side">
          <strong>
            {totalCount} {t("count.ingredients")}
          </strong>
        </div>,
      ]}
      items={ingredientsParsed}
      columns={columnsTable}
      flags={ingredientsParsed}
      onScrollTable={handleScroll}
    />
  );
}

const EditCell = (props) => {
  const { data, rowIndex, style, refetchData } = props;
  const { flags } = data;
  const { id, name } = flags[rowIndex];
  const t = useTranslation();

  return (
    <div
      role="cell"
      style={{ ...style, flexGrow: 1, padding: "1em", border: "" }}
      className="edit cell"
    >
      <DropDownButton icon={<MoreHorizontal />}>
        <IngredientModal
          ingredient={flags[rowIndex]}
          edit
          refetchData={refetchData}
          trigger={
            <div>
              <Edit />
              <p>{t("popup.edit")}</p>
            </div>
          }
        />
        <IngredientDeleteModal
          ingredientName={name}
          ingredientId={id}
          refetchData={refetchData}
          trigger={
            <div className="delete-modal">
              <Delete />
              <p>{t("popup.remove")}</p>
            </div>
          }
        />
      </DropDownButton>
    </div>
  );
};
